import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              Franck Curiotti <span className="text-blue-400">Carrelage</span>
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Artisan carreleur indépendant avec 33 années d'expérience. 
              Carreleur à Saint-Julien-sur-Bibost spécialisé en pose de carrelage 
              dans les Monts du Lyonnais et Lyon Ouest.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="bg-gray-800 hover:bg-blue-600 p-2 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="bg-gray-800 hover:bg-blue-600 p-2 rounded-full transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('accueil')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Galerie
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('process')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Notre Process
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('zone')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Zone d'intervention
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:0608937844" 
                  className="flex items-center text-gray-400 hover:text-blue-400 transition-colors"
                >
                  <Phone className="w-4 h-4 mr-2 flex-shrink-0" />
                  06 08 93 78 44
                </a>
              </li>
              <li>
                <a 
                  href="mailto:franckcuriotti_carrelage@yahoo.fr" 
                  className="flex items-start text-gray-400 hover:text-blue-400 transition-colors break-all"
                >
                  <Mail className="w-4 h-4 mr-2 flex-shrink-0 mt-1" />
                  franckcuriotti_carrelage@yahoo.fr
                </a>
              </li>
              <li>
                <div className="flex items-start text-gray-400">
                  <MapPin className="w-4 h-4 mr-2 flex-shrink-0 mt-1" />
                  <span>
                    122 route départementale 24<br />
                    69690 Saint-Julien-sur-Bibost
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Franck Curiotti Carrelage. Tous droits réservés.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Carreleur à Saint-Julien-sur-Bibost – Monts du Lyonnais – Lyon Ouest
              </p>
            </div>
            <div className="flex gap-6 text-sm">
              <button 
                onClick={() => scrollToSection('mentions')}
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Mentions légales
              </button>
              <button 
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Politique de confidentialité
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Notice Section */}
      <div id="mentions" className="bg-gray-950 py-8">
        <div className="container mx-auto px-4">
          <h3 className="text-xl font-bold mb-4">Mentions Légales</h3>
          <div className="text-sm text-gray-400 space-y-2">
            <p>
              <strong className="text-white">Raison sociale :</strong> Franck Curiotti Carrelage
            </p>
            <p>
              <strong className="text-white">Forme juridique :</strong> Artisan indépendant
            </p>
            <p>
              <strong className="text-white">Adresse :</strong> 122 route départementale 24, 69690 Saint-Julien-sur-Bibost, France
            </p>
            <p>
              <strong className="text-white">Téléphone :</strong> 06 08 93 78 44
            </p>
            <p>
              <strong className="text-white">Email :</strong> franckcuriotti_carrelage@yahoo.fr
            </p>
            <p className="pt-4">
              <strong className="text-white">Activité :</strong> Pose de carrelage, chape, ragréage, 
              rénovation de salle de bain, terrasse et pierre naturelle.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
